module.exports = __webpack_public_path__ + "./docs/img/icon-plus.2617ede16a75fa292947e65fec6ad94f.svg";